export class TrimCardUpdateReq {
    id: number;
    submitDate: string
    seasonData: string;
    styleData: string;
    styleDescription: string;
    factory: string;
    approvalType: string;
    stateData: string;
    factoryMerchandiserSign: string;
    comments: string;
    approvedBy: string;
    constructor(
        id: number,
        submitDate: string,
        seasonData: string,
        styleData: string,
        styleDescription: string,
        factory: string,
        approvalType: string,
        stateData: string,
        factoryMerchandiserSign: string,
        comments: string,
        approvedBy: string,
    ) {
        this.id = id
        this.submitDate = submitDate
        this.seasonData = seasonData
        this.styleData = styleData
        this.styleDescription = styleDescription
        this.factory = factory
        this.approvalType = approvalType
        this.stateData = stateData
        this.factoryMerchandiserSign = factoryMerchandiserSign
        this.comments = comments
        this.approvedBy = approvedBy
    }

}